import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  IconButton,
  TableHead,
} from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import {
  IAMCRequest,
  IFreeConsultancyRequest,
  ITechnician,
} from '../../../utils/entities/interface';
import {
  capitalizeWords,
  formatDateAndTime,
  lockWidth,
} from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { RemoveRedEye, Visibility } from '@mui/icons-material';

import { ToggleTechnicianStatus } from '../../../services/technician';
import { SkeletonRows } from '../../skeletons/list';
import { SquareProfileImage } from '../../atoms/Avatar';
import { DialogBoxComp } from '../../atoms/DialogBox';
import { ListTable } from '../../molecules/ListTable';

export const ConsultancyRequests = ({
  requests,
  isLoading,
  onUpdate,
  tableCell,
}: {
  requests: any[];
  isLoading: boolean;
  onUpdate: () => void;
  tableCell?: any[];
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const [selectedTechnician, setSelectedTechnician] =
    useState<ITechnician | null>(null);

  const handleOpen = (technician: ITechnician) => {
    setSelectedTechnician(technician);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedTechnician(null);
  };

  const handleConfirm = async () => {
    if (selectedTechnician) {
      try {
        await ToggleTechnicianStatus(selectedTechnician._id);
        onUpdate();
        handleClose();
      } catch (error) {
        alert(
          error instanceof Error ? error.message : 'Failed to update status',
        );
      }
    }
  };

  const handleIconClick = (url?: string) => {
    if (!url) return;
    window.open(url, '_blank');
  };

  return (
    <>
      <ListTable
        headerCells={tableCell?.map((cell) => cell) || []}
        rows={requests}
        isLoading={isLoading}
        renderCell={(request: IFreeConsultancyRequest, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return request?.consultancyId || '-';

            case 1:
              return capitalizeWords(request?.userDetails?.name) || 'N/A';

            case 2:
              return `+91-${request?.userDetails.phoneNumber?.slice(0, 10)}`;

            case 3:
              return request?.slot?.replaceAll('_', ' ') || 'N/A';

            case 4:
              return request?.status || 'N/A';

            case 5:
              return (
                <IconButton
                  onClick={() => handleIconClick(request.documentURL)}
                  disabled={!request.documentURL}
                >
                  <RemoveRedEye
                    sx={{
                      color: request.documentURL ? '#7B1FA2' : '#555',
                    }}
                  />
                </IconButton>
              );

            case 6:
              return formatDateAndTime(request?.createdAt) || 'N/A';

            default:
              return null;
          }
        }}
      />

      <DialogBoxComp
        open={open}
        title={
          selectedTechnician?.active
            ? 'Disable Technician'
            : 'Enable Technician'
        }
        content={`Are you sure you want to ${
          selectedTechnician?.active ? 'disable' : 'enable'
        } this technician?`}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
      />
    </>
  );
};
